/* ══════════════════════════════════════════════════════════════════════════
 * 3D product-page templates. A template = one GLB + its model config
 * (anchors, slots, body textures, axes, camera views). The key is what the
 * admin picks as a collection/variation `layout` — keep in sync with the
 * backend allowlist `config('app.three_d_templates')` in
 * ajat_webshop/config/app.php. `palette` = the garment's colour list in
 * config/palette.json (colors.<palette>: UI swatch → 3D tint).
 * The models come from the 3d-hoodie sandbox (config/models/<product>.json,
 * plus `views` added here).
 * ══════════════════════════════════════════════════════════════════════════ */
import hoodie1Model from './hoodie-1/model.json';
import hoodie1Glb from '../../assets/models/hoodie-1.glb';
import tshirt1Model from './tshirt-1/model.json';
import tshirt1Glb from '../../assets/models/tshirt-1.glb';
import vogn1Model from './vogn-1/model.json';
import vogn1Glb from '../../assets/models/vogn-1.glb';

export const THREE_D_TEMPLATES = {
  'hoodie-1': { key: 'hoodie-1', label: 'Hoodie', modelUrl: hoodie1Glb, modelConfig: hoodie1Model, palette: 'hoodie' },
  'tshirt-1': { key: 'tshirt-1', label: 'T-shirt (oversized box fit)', modelUrl: tshirt1Glb, modelConfig: tshirt1Model, palette: 'tshirt' },
  'vogn-1': { key: 'vogn-1', label: 'Vogntrøje', modelUrl: vogn1Glb, modelConfig: vogn1Model, palette: 'vogn' },
};

export const DEFAULT_TEMPLATE_KEY = 'hoodie-1';

/** Registry lookup; null for 'photos' or an unknown key (caller falls back to photos). */
export function getThreeDTemplate(key) {
  return (key && THREE_D_TEMPLATES[key]) || null;
}
